<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/sbe-logo-light.png" alt="" height="40" />
          </span>
          <span class="logo-lg">
            <img src="assets/images/sbe-logo-light.png" alt="" height="40" />
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/sbe-logo-light-sm.png" alt="" height="40" />
          </span>
          <span class="logo-lg">
            <img src="assets/images/sbe-logo-light.png" alt="" height="40" />
          </span>
        </a>
      </div>

      <button
        type="button"
        class="btn btn-sm px-3 font-size-16 header-item d-none d-lg-inline-block"
        id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)"
        aria-label="Toggle sidebar"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>
    </div>

    <div class="d-flex">
      <div class="dropdown d-none d-lg-inline-block ms-1" dropdown>
        <button type="button" class="btn header-item noti-icon d-none" dropdownToggle>
          <i class="bx bx-customize"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end" *dropdownMenu>
          <div class="px-lg-2">
            <div class="row no-gutters">
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/github.png" alt="Github" />
                  <span>GitHub</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/bitbucket.png" alt="bitbucket" />
                  <span>Bitbucket</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/dribbble.png" alt="dribbble" />
                  <span>Dribbble</span>
                </a>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/dropbox.png" alt="dropbox" />
                  <span>Dropbox</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/mail_chimp.png" alt="mail_chimp" />
                  <span>Mail Chimp</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/slack.png" alt="slack" />
                  <span>Slack</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (canCreateCart()) {
        <div class="d-none d-sm-inline-flex align-items-center ms-1">
          <button
            type="button"
            class="btn createCartBtn"
            [disabled]="creatingCart()"
            (click)="createCart()"
          >
            <i class="bx bx-plus me-1"></i>Create Cart
          </button>
        </div>
      }

      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button
          type="button"
          class="btn header-item noti-icon waves-effect"
          data-bs-toggle="fullscreen"
          (click)="fullscreen()"
        >
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <div class="dropdown d-inline-block d-none" dropdown>
        <button
          type="button"
          class="btn header-item noti-icon"
          id="page-header-notifications-dropdown"
          dropdownToggle
        >
          <i class="bx bx-bell bx-tada"></i>
          <span class="badge bg-danger rounded-pill">3</span>
        </button>
        <div
          class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          aria-labelledby="page-header-notifications-dropdown"
          *dropdownMenu
        >
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">Title</h6>
              </div>
              <div class="col-auto">
                <a href="javascript: void(0);" class="small">View All</a>
              </div>
            </div>
          </div>
          <ngx-simplebar style="position: relative; height: 230px">
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="d-flex">
                <div class="avatar-xs me-3">
                  <span class="avatar-title bg-primary rounded-circle font-size-16">
                    <i class="bx bx-cart"></i>
                  </span>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mb-1">Title</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">Text</p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      Time
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </ngx-simplebar>
          <div class="p-2 border-top d-grid">
            <a class="btn btn-sm btn-link font-size-14 text-center" href="javascript:void(0)">
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              <span key="t-view-more">Load More</span>
            </a>
          </div>
        </div>
      </div>

      <div class="dropdown d-inline-block" dropdown>
        <button type="button" class="btn header-item" dropdownToggle id="page-header-user-dropdown">
          <img
            class="rounded-circle header-profile-user"
            [src]="profileImage || fallbackProfileImage"
            (error)="onProfileImageError($event)"
            alt="Header Avatar"
          />
          <span class="d-none d-xl-inline-block ms-1" [title]="userName">{{
            displayUserName
          }}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
          <!-- item-->

          <a
            class="dropdown-item d-block"
            routerLink="/profile/view"
            [class.active]="isProfileActive"
          >
            <i class="bx bx-user font-size-16 align-middle me-1"></i>Profile
          </a>
          <a
            class="dropdown-item d-block"
            routerLink="/profile/change-password"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <i class="bx bx-lock-alt font-size-16 align-middle me-1"></i>Change Password
          </a>

          <div class="dropdown-divider"></div>
          <button class="dropdown-item text-danger" type="button" (click)="logout()">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> Logout
          </button>
        </div>
      </div>

      <div class="dropdown d-inline-block">
        <button
          type="button"
          class="btn header-item noti-icon right-bar-toggle d-none"
          (click)="toggleRightSidebar()"
        >
          <i class="bx bx-cog bx-spin"></i>
          <i class="bx bx-menu"></i>
        </button>
      </div>
      <!-- mobile menu -->
      <button type="button" class="mobileMenuToggle d-lg-none" (click)="toggleResponsiveMenu()">
        <i class="bx bx-menu"></i>
      </button>
      <!-- mobile menu -->
    </div>
  </div>
</header>
